import React from 'react';
import PropTypes from 'prop-types';

const DEFAULT_VIEWS = [
  { key: 'new', label: 'New view' },
  { key: 'classic', label: 'Classic view' }
];

/**
 * Buttons that switch a section between its views: the improved one first, as
 * the default, then the original, kept one click away; a section can add more.
 */
export default function ViewSwitch({ value, onChange, views = DEFAULT_VIEWS }) {
  return (
    <div style={{ marginBottom: 16 }}>
      {views.map(({ key, label }) => (
        <button
          key={key}
          type="button"
          className={`button button-shrink-limited ${value === key ? 'button-color-primary' : 'button-color-secondary'}`}
          style={{ marginRight: 8 }}
          onClick={() => onChange(key)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

ViewSwitch.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  views: PropTypes.arrayOf(PropTypes.shape({ key: PropTypes.string.isRequired, label: PropTypes.string.isRequired }))
};
